import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getJobStory = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_STORY,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Historial_Laboral/' : `/api/app/Funcional_Historial_Laboral/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_JOB_STORY,
      payload: {
        jobStory: resp.data.data,
        jobStoryLength: resp.data.count,
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_JOB_STORY,
      payload: false
    });
  }
}

export const saveJobStory = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_JOB_STORY,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Historial_Laboral/' : '/api/app/Funcional_Historial_Laboral/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { jobStory, jobStoryLength } = getState().jobStory;
    const aJobStory= [...jobStory, resp.data];
    dispatch({
      type: actions.GET_JOB_STORY,
      payload: {
        jobStory: aJobStory,
        jobStoryLength: jobStoryLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_JOB_STORY,
      payload: false
    });
  }
}

export const editJobStory = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_JOB_STORY,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Historial_Laboral/${id}/` : `/api/app/Funcional_Historial_Laboral/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { jobStory, jobStoryLength } = getState().jobStory;
    jobStory[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_JOB_STORY,
      payload: {
        jobStory: jobStory,
        jobStoryLength: jobStoryLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_JOB_STORY,
      payload: false
    });
  }
}

export const deleteJobStory = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOB_STORY,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Historial_Laboral/${id}/` : `/api/app/Funcional_Historial_Laboral/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { jobStory, jobStoryLength } = getState().jobStory;
    jobStory.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_JOB_STORY,
      payload: {
        jobStory: jobStory,
        jobStoryLength: jobStoryLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_JOB_STORY,
      payload: false
    });
  }
}
